/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GA4_EVENT_VIEW_CART, PAGE_DATA_LAYER } from '@/data/constants/gtm';
import { getGTMCartViewEventData } from '@/data/events/data/gtm/CartView';
import { getGTMConfig } from '@/data/events/handlers/gtm';
import { GTMCartViewPayload } from '@/data/types/GTM';
import { error as logError } from '@/data/utils/loggerUtil';
import TagManager from 'react-gtm-module';

/**
 * Measure view cart process into the Data Layer using the view cart action.
 * @param data transformed input payload from cart-view event (see data-type)
 */
export const measure_GA4 = async (data: Awaited<ReturnType<typeof getGTMCartViewEventData>>) => {
	const { cart, products } = data;
	const dataLayerName = PAGE_DATA_LAYER;

	const { grandTotalCurrency: currency, grandTotal: value } = cart;
	const tagManagerArgsGA4 = {
		dataLayer: {
			event: GA4_EVENT_VIEW_CART,
			ecommerce: {
				currency,
				value: Number(value),
				items: products,
			},
		},
		dataLayerName,
	};
	TagManager.dataLayer(tagManagerArgsGA4);
};

export const sendGTMCartViewEvent = async (payload: GTMCartViewPayload) => {
	const { settings } = payload;
	const { ga4 } = getGTMConfig(settings);
	if (ga4) {
		const data = await getGTMCartViewEventData(payload);
		try {
			await measure_GA4(data);
		} catch (error) {
			logError(undefined, 'CartView: sendGTMCartViewEvent: error: %o', error);
		}
	}
};
